import { render, staticRenderFns } from "./FichaDeEstoque.vue?vue&type=template&id=03412f27&"
import script from "./FichaDeEstoque.vue?vue&type=script&lang=js&"
export * from "./FichaDeEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports